<!-- login.component.html -->

<div class="login">

    <p-dropdown [options]="listLang" [(ngModel)]="selectedLang" placeholder="Select a Lang" optionLabel="name"
        [showClear]="true" (onChange)="onChangeLang()" class="custom-dropdown"></p-dropdown>


    <div class="login_form p-as-center p-mt-auto p-mb-auto">
        <div class="login_form-content p-d-flex p-flex-column">
            <div class="flex flex-column p-px-3 p-py-3">
                <div style="display: flex !important; justify-content: center; margin: 1rem 0;">
                    <img src="assets/layout/images/tovpil_logo.png" alt="Login Icon" style="height: 15%; width: 15%" />
                </div>
                <div class="mt-4" style="text-align: center;">
                    <h1 class="m-0 text-primary font-semibold text-4xl">
                        {{ 'login.title' | translate }}
                    </h1>
                    <span class="block text-700 mt-2">{{ 'login.instruction' | translate }} </span>
                </div>
            </div>
            <form [formGroup]="loginForm">
                <div class="input-panel p-d-flex p-flex-column p-px-3">
                    <div class="p-inputgroup">
                        <span [ngClass]="{ 'is-invalid': submitted && f.username.errors }" class="p-inputgroup-addon">
                            <i class="pi pi-envelope"></i>
                        </span>
                        <span class="p-float-label">
                            <input type="text" formControlName="username"
                                [ngClass]="{ 'is-invalid': submitted && f.username.errors }" pInputText
                                style="width: 100%;">
                            <label for="username">{{ 'login.user' | translate }}</label>
                        </span>

                    </div>
                    <div class="p-inputgroup p-mt-3 p-mb-6">
                        <span [ngClass]="{ 'is-invalid': submitted && f.username.errors }" class="p-inputgroup-addon">
                            <i class="pi pi-lock"></i>
                        </span>
                        <span class="p-float-label">
                            <input type="password" formControlName="password"
                                [ngClass]="{ 'is-invalid': submitted && f.password.errors }" pInputText
                                style="width: 100%;">
                            <label for="password">{{ 'login.password' | translate }}</label>
                        </span>
                    </div>
                    <div class="mt-4" style="text-align: center;">
                        <span *ngIf="responseCode === 'R-0600'" style="color: red;" class="block text-700 mt-2">{{
                            'login.incorrectPassword' | translate }}
                        </span>
                        <span *ngIf="responseCode === 'R-1000'" style="color: red;" class="block text-700 mt-2">{{
                            'login.isMaintence' | translate }}
                        </span>
                        <br /><br />
                    </div>

                    <div class="container text-center">
                        <router-outlet></router-outlet>
                    </div>
                    <p-button [disabled]="loading" label="{{ 'button.accept' | translate }}" (onClick)="onSubmit()">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    </p-button>
                </div>
            </form>
        </div>
    </div>
    <div class="login_page p-d-flex p-flex-column">
        <p-carousel [value]="images" [numVisible]="1" [numScroll]="1" [autoplayInterval]="3000"
            [responsiveOptions]="responsiveOptions" class="no-indicators">
            <ng-template let-image pTemplate="item">
                <img src="assets/layout/images/tovpil/{{image}}" [alt]="image" class="image_carousel" />
            </ng-template>
        </p-carousel>
    </div>
</div>